module.exports = __webpack_public_path__ + "img/BTCP.81739d86.svg";